import { render, staticRenderFns } from "./add-vertical.component.html?vue&type=template&id=601ce054&scoped=true&external"
import script from "./add-vertical.component.vue?vue&type=script&lang=ts"
export * from "./add-vertical.component.vue?vue&type=script&lang=ts"
import style0 from "./add-vertical.component.css?vue&type=style&index=0&id=601ce054&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601ce054",
  null
  
)

export default component.exports